<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить тарифный план</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'rate-plans' }">← Назад к Тарифным планам</router-link>
    </div>

    <rate-plan-add-form @after="handleAfter" />

  </div>
</template>

<script>
import ratePlanAddForm from '@/components/forms/rate_plan/RatePlanAddForm'

export default {
  name: 'rate-plan-add',
  components: { ratePlanAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'rate-plans' })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// RatePlanAdd.vue?054f766e